<google-map height="85vh" width="100%" [center]="center" [zoom]="zoom">
  <map-marker
    *ngFor="let driver of drivers"
    [position]="driver.location"
    [icon]="motorbikeIcon"
    [title]="driver.id"
    (mapClick)="onMarkerClick(driver.id)"
    #marker="mapMarker"
  >
  </map-marker>
  <map-info-window
    *ngFor="let userId of selectedDriverIds"
    [position]="getDriverLocation(userId)"
    (closeclick)="onInfoWindowClose(userId)"
  >
    <div>
      <p><strong>name:</strong> {{ getDriverName(userId) }}</p>
      <p><strong>ID:</strong> {{ userId }}</p>
      <p>
        <strong>Location:</strong> {{ getDriverLocation(userId).lat }}, {{
        getDriverLocation(userId).lng }}
      </p>
      <!-- Add more driver details as needed -->
    </div>
  </map-info-window>
</google-map>
